import "./StudentsAndInstitutes.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import Benvenuto from "./sections/Benvenuto";
import ThePropAdvantage from "./sections/ThePropAdvantage";
import EnvieSuaMensagem from "./sections/EnvieSuaMensagem";
import Footer from "@/reusable_sections/Footer";
export default function StudentsAndInstitutesPage() {
  return <div>
      <GatewayNavigation />
      <Benvenuto />
      <ThePropAdvantage />
      <EnvieSuaMensagem />
      <Footer />
    </div>;
}